module.exports = __webpack_public_path__ + "img/apple.4482c906.png";